import { Label } from 'shared/components/ui/Typography'
import styled from 'react-emotion'
import SpacedItems from 'shared/components/ui/SpacedItems'
import {
  nano,
  large,
  big,
  ultraLight,
} from 'ui_theme/site/globals/site.variables'

const Hint = styled('span')`
  color: ${ultraLight};
  align-self: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`

const Suggestion = styled('div')`
  display: flex;
  margin-bottom: ${nano}
  :last-child {
    margin-bottom: 0px;
  }
`

const Container = styled(SpacedItems.Container)`
  padding: ${large} ${big} 0px ${big}};
`

export default function InvalidSearchMessage() {
  return (
    <Container gap="tiny" direction="vertical">
      <SpacedItems.Item>
        <Label size="large" color="berry">
          Invalid search
        </Label>
      </SpacedItems.Item>
      <SpacedItems.Item>
        {
          "You have used a search operator that doesn't exist. Try one of these instead..."
        }
      </SpacedItems.Item>
      <SpacedItems.Item>
        <Suggestion>
          <Label size="small" color="inherit" as="span">
            my:
          </Label>
          <Hint>state or drafts</Hint>
        </Suggestion>
        <Suggestion>
          <Label size="small" color="inherit" as="span">
            is:
          </Label>
          <Hint>state, unassigned or assigned</Hint>
        </Suggestion>
        <Suggestion>
          <Label size="small" color="inherit" as="span">
            assignee:
          </Label>
          <Hint>username, me or unassigned</Hint>
        </Suggestion>
        <Suggestion>
          <Label size="small" color="inherit" as="span">
            mentions:
          </Label>
          <Hint>username or me</Hint>
        </Suggestion>
        <Suggestion>
          <Label size="small" color="inherit" as="span">
            rating:
          </Label>
          <Hint>awesome, ok, bad</Hint>
        </Suggestion>
        <Suggestion>
          <Label size="small" color="inherit" as="span">
            group:
          </Label>
          <Hint>group name or unassigned</Hint>
        </Suggestion>
        <Suggestion>
          <Label size="small" color="inherit" as="span">
            drafts:
          </Label>
          <Hint>agent username or me</Hint>
        </Suggestion>
        <Suggestion>
          <Label size="small" color="inherit" as="span">
            folder:
          </Label>
          <Hint>folder name</Hint>
        </Suggestion>
        <Suggestion>
          <Label size="small" color="inherit" as="span">
            tag:
          </Label>
          <Hint>tag name</Hint>
        </Suggestion>
      </SpacedItems.Item>
    </Container>
  )
}
